export default __webpack_public_path__ + "static/media/Path 21552.1fbcc244.svg";